module.exports = __webpack_public_path__ + "static/media/logoSTI.4c5b9118.png";